import {changeFilteredInfo} from "@/utils/data/tableCol/tableUtils";

export const recordChecks = (filteredInfos) => {
    let filteredInfo = changeFilteredInfo(filteredInfos)
    return [
        {
            title: '操作',
            key: 'operation',
            scopedSlots: {customRender: 'operation'},
            width: 100
        },
        {
            title: '合同编号',
            dataIndex: 'contractNumbers',
            key: 'contractNumber',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contractNumbers'
            },
            filteredValue: filteredInfo.contractNumber || [],
        },
        {
            title: '发票抬头',
            dataIndex: 'invoiceTitle',
            key: 'invoiceTitle',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'invoiceTitle'
            },
        },
        {
            title: '客户',
            dataIndex: 'contactName',
            key: 'contactName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'contactName'
            },
            filteredValue: filteredInfo.contactName || [],
        },
        {
            title: '合同发票总数',
            dataIndex: 'requestNumberOfInvoices',
            key: 'requestNumberOfInvoices'
        },
        {
            title: '是否可连号',
            dataIndex: 'connectedFlag',
            key: 'connectedFlag',
            scopedSlots: {
                filterDropdown: 'filterFlag',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'connectedFlag'
            },
            filteredValue: filteredInfo.connectedFlag || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '是否同一天',
            dataIndex: 'sameDayFlag',
            key: 'sameDayFlag',
            scopedSlots: {
                filterDropdown: 'filterFlag',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'sameDayFlag'
            },
            filteredValue: filteredInfo.sameDayFlag || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '销售',
            dataIndex: 'applicant.name',
            key: 'saleName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.saleName || [],
        },
        {
            title: '申请日期',
            dataIndex: 'applicationDate',
            key: 'applicationDate',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核状态',
            dataIndex: 'status',
            key: 'status',
            scopedSlots: {
                filterDropdown: 'filterStatus',
                filterIcon: 'filterIcon',
                filtered: true,
                customRender: 'status'
            },
            filteredValue: filteredInfo.status || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核人员',
            dataIndex: 'operatingPersonName',
            key: 'operatingPersonName',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.operatingPersonName || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '审核时间',
            dataIndex: 'operatingTime',
            key: 'operatingTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建人',
            dataIndex: 'createBy',
            key: 'createBy',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.createBy || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '创建时间',
            dataIndex: 'createTime',
            key: 'createTime',
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
        {
            title: '备注',
            dataIndex: 'remark',
            key: 'remark',
            scopedSlots: {
                filterDropdown: 'filterDropdown',
                filterIcon: 'filterIcon',
                filtered: true,
            },
            filteredValue: filteredInfo.remark || [],
            sorter: true,
            sortDirections: ["descend", "ascend", "descend"]
        },
    ]
}
